class MobileMenu extends HTMLElement {
  constructor() {
    super();
    this.isOpen = false;
    this.link = this.querySelectorAll("[data-mobile-link-parent]");
    this.backSublist = this.querySelectorAll("[data-back-sublist]");
    this.sublist = this.querySelectorAll("[data-mobile-menu-sublist]");

    this.init();
  }

  init() {
    document.querySelectorAll("[data-toggle-mobile-menu]").forEach((button) => {
      button.addEventListener("click", () => this.toggleMenu());
    });

    this.link.forEach((item) => {
      item.addEventListener("click", (event) => {
        event.preventDefault();
        const parentIndex = event.currentTarget.getAttribute("data-mobile-link-parent");
        const sublist = this.querySelector(`[data-mobile-menu-sublist="${parentIndex}"]`);
        if (sublist) {
          sublist.classList.toggle("open");
          event.stopPropagation();
        }
      });
    });

    this.backSublist.forEach((button) => {
      button.addEventListener("click", (event) => {
        event.preventDefault();
        const sublist = event.currentTarget.closest(".mobile-menu__sublist");
        if (sublist) {
          sublist.classList.remove("open");
          event.stopPropagation();
        }
      });
    });

    document.addEventListener("mousedown", (event) => {
      if (!this.isOpen) return;
      if (!this.contains(event.target)) {
        this.toggleMenu();
      }
    });
  }

  toggleMenu() {
    this.isOpen = !this.isOpen;
    if (this.isOpen) {
      this.classList.add("open");
      document.body.classList.add("muted");
    } else {
      this.classList.remove("open");
      document.body.classList.remove("muted");
    }
  }
}

customElements.define("mobile-menu", MobileMenu);

class HeaderSearch extends HTMLElement {
  constructor() {
    super();
    this.searchWrap = this.querySelector(".header__search-wrap");
    this.toggleButton = this.querySelectorAll("[data-toggle-search]");
    this.isOpen = false;
    this.init();
  }

  init() {
    this.toggleButton.forEach((button) => {
      button.addEventListener("click", (e) => {
        e.preventDefault();
        this.isOpen = !this.isOpen;
        this.searchWrap.classList.toggle("open", this.isOpen);
        if (this.isOpen) {
          this.querySelector("input[name='q']").focus();
        }
      });
    });

    document.addEventListener("mousedown", (event) => {
      if (!this.isOpen) return;
      if (!this.contains(event.target)) {
        event.preventDefault();
        this.isOpen = false;
        this.searchWrap.classList.remove("open");
      }
    });
  }
}

customElements.define("header-search", HeaderSearch);

class Megamenu extends HTMLElement {
  constructor() {
    super();

    this.handleLinkHover();
  }

  handleLinkHover() {
    document.querySelectorAll(".header__nav-item[data-has-submenu]").forEach((item) => {
      item.addEventListener("mouseenter", () => {
        document.body.classList.add("muted-scrollable");
      });

      item.addEventListener("mouseleave", () => {
        document.body.classList.remove("muted-scrollable");
      });
    });
  }
}

customElements.define("header-megamenu", Megamenu);

class HeroProducts extends HTMLElement {
  constructor() {
    super();

    this.slider = this.querySelector(".swiper");
    this.swiper = null;
    this.init();
  }

  init() {
    this.swiper = new Swiper(this.slider, {
      slidesPerView: 1,
      spaceBetween: 0,
      loop: true,
      pagination: {
        el: ".swiper-pagination",
        type: "bullets",
        clickable: true,
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
    });
  }
}

customElements.define("hero-products", HeroProducts);

class CollectionsTabs extends HTMLElement {
  constructor() {
    super();
    this.tabs = this.querySelectorAll("[data-collection-tab]");
    this.content = this.querySelectorAll("[data-collection-tab-content]");
    this.slider = this.querySelectorAll(".collection-tabs__slider");
    this.init();
  }

  init() {
    this.tabs.forEach((tab) => {
      tab.addEventListener("click", () => {
        let id = tab.getAttribute("data-collection-tab");
        this.tabs.forEach((tab) => {
          tab.classList.remove("active");
        });
        tab.classList.add("active");
        this.content.forEach((content) => {
          if (content.getAttribute("data-collection-tab-content") === id) {
            content.classList.add("active");
          } else {
            content.classList.remove("active");
          }
        });
      });
    });

    this.slider.forEach((slider) => {
      new Swiper(slider, {
        slidesPerView: "auto",
        spaceBetween: 16,
        breakpoints: {
          768: {
            spaceBetween: 30,
          },
        },
        pagination: {
          el: ".swiper-pagination",
          type: "progressbar",
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      });
    });
  }
}

customElements.define("collections-tabs", CollectionsTabs);

class MarqueeSection extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector(".swiper");
    this.swiper = null;
    this.init();
  }

  init() {
    this.swiper = new Swiper(this.slider, {
      slidesPerView: "auto",
      spaceBetween: 30,
      loop: true,
      speed: 6000,
      allowTouchMove: false,
      autoplay: {
        delay: 1,
        disableOnInteraction: false,
      },
      breakpoints: {
        768: {
          spaceBetween: 80,
        },
        992: {
          spaceBetween: 100,
        },
      },
    });
  }
}

customElements.define("marquee-section", MarqueeSection);

class HotpointsSection extends HTMLElement {
  constructor() {
    super();

    this.buttons = this.querySelectorAll("[data-hotpoint-button]");
    this.contents = this.querySelectorAll("[data-hotpoint-content]");
    this.nextButton = this.querySelectorAll("[data-next-hotpoint]");

    this.currentIndex = 1;
    this.maxIndex = this.buttons.length;

    this.init();
  }

  init() {
    this.buttons.forEach((button) => {
      button.addEventListener("click", () => {
        this.currentIndex = parseInt(button.getAttribute("data-hotpoint-button"));
        this.showContent(this.currentIndex);
      });
    });

    this.nextButton.forEach((button) => {
      button.addEventListener("click", () => {
        this.currentIndex++;
        if (this.currentIndex > this.maxIndex) {
          this.currentIndex = 1;
        }
        this.showContent(this.currentIndex);
      });
    });
  }

  showContent(index) {
    this.contents.forEach((content) => {
      content.classList.remove("active");
      if (parseInt(content.getAttribute("data-hotpoint-content")) === index) {
        content.classList.add("active");
      }
    });

    this.buttons.forEach((button) => {
      button.classList.remove("active");
      if (parseInt(button.getAttribute("data-hotpoint-button")) === index) {
        button.classList.add("active");
      }
    });
  }
}

customElements.define("hotpoints-section", HotpointsSection);

class ReviewsSlider extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector(".swiper");
    this.swiper = null;

    this.init();
  }

  init() {
    this.swiper = new Swiper(this.slider, {
      slidesPerView: 1,
      spaceBetween: 0,
      loop: true,
      effect: "fade",
      fadeEffect: {
        crossFade: true,
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
    });
  }
}

customElements.define("reviews-slider", ReviewsSlider);

class CollectionMain extends HTMLElement {
  constructor() {
    super();
    this.isCollapsed = localStorage.getItem("collectionMainCollapsed") === "true";
    this.collapseDesktopFiltersButton = this.querySelector("[data-collapse-desktop-filters]");
    this.filtersWrap = this.querySelector("[data-filters-wrap]");
    this.productsGrid = this.querySelector("[data-products-grid]");
    this.pagination = this.querySelector("[data-pagination-wrap]");
    this.showingString = this.querySelector("[data-showing-string]");
    this.filterCollapseButtons = this.querySelectorAll("[data-filter-collapse]");
    this.mobileFiltersToggle = this.querySelectorAll("[data-mobile-filters-toggle]");
    this.sortSelect = this.querySelector("[data-sort]");
    this.currentSort = this.sortSelect.value;
    this.filterURL = location.pathname;
    this.visibleURL = location.pathname;
    this.search = this.getAttribute("data-search");
    this.filterInputs = this.querySelectorAll("input[data-filter-value]");
    this.currentPage = 1;

    this.init();
  }

  init() {
    if (this.isCollapsed) {
      this.toggleCollapseFilters();
    }

    this.collapseDesktopFiltersButton.addEventListener("click", () => {
      this.isCollapsed = !this.isCollapsed;
      localStorage.setItem("collectionMainCollapsed", this.isCollapsed);
      this.toggleCollapseFilters();
    });

    this.mobileFiltersToggle.forEach((button) => {
      button.addEventListener("click", () => {
        this.filtersWrap.classList.toggle("active");
      });
    });

    this.filterCollapseButtons.forEach((button) => {
      button.addEventListener("click", () => {
        button.classList.toggle("active");
      });
    });

    this.filterInputs.forEach((input) => {
      input.addEventListener("change", (e) => {
        if (input.checked && input.hasAttribute("data-filter-radio")) {
          input
            .closest(".filter__options")
            .querySelectorAll("input")
            .forEach((i) => {
              i.checked = false;
            });
          input.checked = true;
        }
        this.filterCollection();
      });
    });

    this.addEventListener("click", (e) => {
      if (e.target.closest("[data-page]")) {
        e.preventDefault();
        this.currentPage = +e.target.closest("[data-page]").getAttribute("data-page");
        this.filterCollection(true);
      }
    });

    this.sortSelect.addEventListener("change", (e) => {
      this.currentSort = e.target.value;
      this.filterCollection();
    });
  }

  toggleCollapseFilters() {
    this.filtersWrap.classList.toggle("open");
    this.collapseDesktopFiltersButton.classList.toggle("active");
    localStorage.setItem("collectionMainCollapsed", this.isCollapsed);
    this.productsGrid.classList.toggle("active");
  }

  filterCollection(scrollToTop = false) {
    this.classList.add("loading");
    let urlParams = [];
    this.querySelectorAll("input[data-filter-value]:checked").forEach((input) => {
      urlParams.push(`${input.getAttribute("name")}=${input.value}`);
    });
    this.filterParams = `${urlParams.join("&")}`;
    this.currentSort = this.sortSelect.value;
    this.visibleURL = `${location.pathname}?${this.filterParams}&sort_by=${this.currentSort}&page=${this.currentPage}${this.search ? `&q=${encodeURI(this.search)}` : ""}`;
    this.filterURL = `${location.pathname}?${this.filterParams}&sort_by=${this.currentSort}&view=ajax&page=${this.currentPage}${this.search ? `&q=${encodeURI(this.search)}` : ""}`;

    window.history.replaceState({}, "", this.visibleURL);

    fetch(this.filterURL)
      .then((response) => response.text())
      .then((data) => {
        let html_div = document.createElement("div");
        html_div.innerHTML = data;
        this.productsGrid.innerHTML = "";
        this.pagination.innerHTML = "";
        this.showingString.innerHTML = "";

        let productsGridHTML = html_div.querySelector("[data-products-grid]").innerHTML;
        let paginationHTML = html_div.querySelector("[data-pagination-wrap]").innerHTML;
        let showingStringHTML = html_div.querySelector("[data-showing-string]").innerHTML;

        this.productsGrid.innerHTML = productsGridHTML;
        this.pagination.innerHTML = paginationHTML;
        this.showingString.innerHTML = showingStringHTML;
      })
      .catch((error) => console.error("Error:", error))
      .finally(() => {
        this.classList.remove("loading");
        if (scrollToTop) {
          const topPosition = this.productsGrid.getBoundingClientRect().top + window.pageYOffset - 150;
          window.scrollTo({
            top: topPosition,
            behavior: "smooth",
          });
        }
      });
  }

  renderCollection() {}
}

customElements.define("collection-main", CollectionMain);

class CollapsibleItem extends HTMLElement {
  constructor() {
    super();
    this.faqButton = this.querySelector("[data-faq-button]");
    this.init();
  }

  init() {
    this.faqButton.addEventListener("click", (e) => {
      this.classList.toggle("collapsed");
    });
  }
}

customElements.define("collapsible-item", CollapsibleItem);

class ProductMain extends HTMLElement {
  constructor() {
    super();
    this.mainSlider = this.querySelector(".product-gallery-main");
    this.thumbSlider = this.querySelector(".product-gallery-thumbs");

    this.variantSelect = this.querySelector("[data-product-variant-select]");
    this.productQuantity = this.querySelector("[data-product-quantity]");
    this.productForm = this.querySelector("[data-product-form]");
    this.productPrice = this.querySelector("[data-product-price]");
    this.productCompareAtPrice = this.querySelector("[data-product-compare-at-price]");
    this.productStock = this.querySelector("[data-product-stock]");
    this.productSku = this.querySelector("[data-product-sku]");
    this.productSkuWrapper = this.querySelector("[data-product-sku-wrapper]");
    this.productATC = this.querySelector("[data-product-atc]");
    this.complementaryProductsSwiper = this.querySelector("[data-complementary-products-swiper]");
    this.product = { ...window.product };
    this.selectedVariant = null;
    this.variantIdInput = this.querySelector("[data-product-variant-id]");
    this.optionSelects = this.querySelectorAll("[data-product-option-select]");
    this.selectedVariantId = +this.variantIdInput.value;

    this.mainSwiper = null;
    this.thumbSwiper = null;

    this._zoomLens = null;
    this._zoomTarget = null;

    this.init();
    this.initEvents();
    this.updateVariant(true);
  }

  initEvents() {
    if (this.variantSelect) {
      this.variantSelect.addEventListener("change", (e) => {
        this.updateVariant();
      });
    }
  }

  init() {
    this.thumbSwiper = new Swiper(this.thumbSlider, {
      slidesPerView: 4,
      spaceBetween: 10,
      clickable: true,
      freeMode: true,
      watchSlidesProgress: true,
    });

    this.mainSwiper = new Swiper(this.mainSlider, {
      slidesPerView: 1,
      spaceBetween: 0,
      loop: true,
      effect: "slide",
      thumbs: {
        swiper: this.thumbSwiper,
      },
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      clickable: true,
    });

    if (this.complementaryProductsSwiper) {
      this.complementaryProductsSwiper = new Swiper(this.complementaryProductsSwiper, {
        slidesPerView: 1,
        spaceBetween: 0,
        loop: true,
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
      });
    }
    this.optionSelects.forEach((select) => {
      select.addEventListener("change", (e) => {
        this.updateVariant();
      });
    });

    this.initHoverZoom();
  }

  initHoverZoom() {
    const gallery = this.querySelector(".product-gallery");
    if (!gallery) return;

    gallery.addEventListener("mousemove", (e) => {
      const target = e.target.closest("[data-zoom-image]");

      if (target && target !== this._zoomTarget) {
        this._zoomTarget = target;
        this._showZoomLens(target);
      }

      if (target) {
        this._moveZoomLens(e, target);
      } else if (this._zoomTarget) {
        this._zoomTarget = null;
        this._hideZoomLens();
      }
    });

    gallery.addEventListener("mouseleave", () => {
      if (this._zoomTarget) {
        this._zoomTarget = null;
        this._hideZoomLens();
      }
    });
  }

  _createZoomLens() {
    if (this._zoomLens) return;

    const lens = document.createElement("div");
    Object.assign(lens.style, {
      position: "fixed",
      zIndex: "1000",
      width: "280px",
      height: "280px",
      borderRadius: "8px",
      border: "2px solid rgba(255,255,255,0.6)",
      boxShadow: "0 8px 30px rgba(0,0,0,0.35)",
      overflow: "hidden",
      pointerEvents: "none",
      display: "none",
      backgroundRepeat: "no-repeat",
      backgroundColor: "#f0f0f0",
      transition: "opacity 0.15s ease",
      opacity: "0",
    });

    document.body.appendChild(lens);
    this._zoomLens = lens;
  }

  _showZoomLens(target) {
    const src = target.getAttribute("data-zoom-image");
    if (!src) return;

    this._createZoomLens();
    target.style.cursor = "crosshair";

    this._zoomNatRatio = null;
    const img = new Image();
    img.onload = () => {
      this._zoomNatRatio = img.naturalHeight / img.naturalWidth;
    };
    img.src = src;

    this._zoomLens.style.backgroundImage = `url('${src}')`;
    this._zoomLens.style.display = "block";
    requestAnimationFrame(() => {
      this._zoomLens.style.opacity = "1";
    });
  }

  _moveZoomLens(e, target) {
    if (!this._zoomLens) return;

    const rect = target.getBoundingClientRect();
    const lensW = 280;
    const lensH = 280;
    const zoomScale = 2.5;

    const fracX = Math.max(0, Math.min(1, (e.clientX - rect.left) / rect.width));
    const fracY = Math.max(0, Math.min(1, (e.clientY - rect.top) / rect.height));

    const bgW = rect.width * zoomScale;
    const bgH = this._zoomNatRatio ? bgW * this._zoomNatRatio : rect.height * zoomScale;

    const bgX = -(fracX * bgW - lensW / 2);
    const bgY = -(fracY * bgH - lensH / 2);

    this._zoomLens.style.backgroundSize = `${bgW}px ${bgH}px`;
    this._zoomLens.style.backgroundPosition = `${bgX}px ${bgY}px`;

    const vw = window.innerWidth;
    const vh = window.innerHeight;
    let lensX = e.clientX - lensW / 2;
    let lensY = e.clientY - lensH / 2;
    lensX = Math.max(4, Math.min(vw - lensW - 4, lensX));
    lensY = Math.max(4, Math.min(vh - lensH - 4, lensY));

    this._zoomLens.style.left = `${lensX}px`;
    this._zoomLens.style.top = `${lensY}px`;
  }

  _hideZoomLens() {
    if (!this._zoomLens) return;
    this._zoomLens.style.opacity = "0";
    setTimeout(() => {
      if (!this._zoomTarget) {
        this._zoomLens.style.display = "none";
      }
    }, 150);
  }

  updateVariant(initial = false) {
    if (this.optionSelects.length) {
      let variantTitle = null;
      let variantTitles = [];
      this.optionSelects.forEach((select) => {
        variantTitles.push(select.value);
      });
      variantTitle = variantTitles.join(" / ");

      this.selectedVariant = this.product.variants.find((variant) => {
        return variant.title === variantTitle;
      });
    } else {
      this.selectedVariant = this.product.variants[0];
    }
    this.variantIdInput.value = this.selectedVariant.id;
    this.updatePrice();
    this.updateStock();
    this.updateSku();
    this.updateATC();
    this.updateVariantMedia();
    if (!initial) {
      this.updateVariantUrl();
    }
  }

  updatePrice() {
    this.productPrice.textContent = this.formatMoney(this.selectedVariant.price);
    if (this.selectedVariant.compare_at_price) {
      this.productCompareAtPrice.textContent = this.formatMoney(this.selectedVariant.compare_at_price);
    } else {
      this.productCompareAtPrice.textContent = "";
    }
  }

  formatMoney(price) {
    return new Intl.NumberFormat("en-US", { style: "currency", currency: "USD" }).format(price / 100);
  }

  updateStock() {
    if (this.selectedVariant.available) {
      this.productStock.classList.add("active");
      this.productStock.textContent = window.themeVariables.strings.in_stock;
    } else {
      this.productStock.classList.remove("active");
      this.productStock.textContent = window.themeVariables.strings.out_of_stock;
    }
  }

  updateSku() {
    if (this.selectedVariant.sku) {
      this.productSkuWrapper.classList.remove("hidden");
      this.productSku.textContent = this.selectedVariant.sku;
    } else {
      this.productSku.textContent = "";
      this.productSkuWrapper.classList.add("hidden");
    }
  }

  updateATC() {
    if (this.selectedVariant.available) {
      this.productATC.removeAttribute("disabled");
    } else {
      this.productATC.setAttribute("disabled", true);
    }
  }

  updateVariantMedia() {
    if (this.selectedVariant.featured_media) {
      const position = this.selectedVariant.featured_media.position;
      this.mainSwiper.slideTo(position - 1);
      this.thumbSwiper.slideTo(position - 1);
    }
  }

  updateVariantUrl() {
    window.history.replaceState({}, "", location.pathname + "?variant=" + this.selectedVariant.id);
  }
}

customElements.define("product-main", ProductMain);

class BlogMain extends HTMLElement {
  constructor() {
    super();
    this.tags = this.querySelectorAll("[data-blog-tag]");
    this.slider = this.querySelector(".swiper");
    this.tags = this.querySelectorAll("[data-blog-tag]");
    this.blogGrid = this.querySelector("[data-blog-articles]");
    this.pagination = this.querySelector("[data-pagination-wrap]");
    this.tagUrl = location.pathname;
    this.filterURL = location.pathname;
    this.visibleURL = location.pathname;
    this.currentTag = "all";
    this.currentPage = 1;
    this.init();
  }

  init() {
    if (this.slider) {
      this.swiper = new Swiper(this.slider, {
        slidesPerView: "auto",
        spaceBetween: 0,
        freeMode: true,
        scrollbar: {
          el: ".swiper-scrollbar",
          draggable: true,
        },
      });

      this.addEventListener("click", (e) => {
        if (e.target.closest("[data-page]")) {
          e.preventDefault();
          this.currentPage = +e.target.closest("[data-page]").getAttribute("data-page");
          this.filterBlog();
        }
      });
    }

    this.tags.forEach((tag) => {
      tag.addEventListener("click", (e) => {
        e.preventDefault();
        this.tagUrl = e.target.closest("[data-blog-tag]").getAttribute("data-blog-tag");
        this.currentPage = 1;
        this.tags.forEach((tag) => {
          tag.classList.remove("active");
        });
        e.target.closest("[data-blog-tag]").classList.add("active");
        this.filterBlog();
      });
    });
  }

  filterBlog() {
    this.classList.add("loading");

    this.filterURL = `${this.tagUrl}?page=${this.currentPage}&view=ajax`;
    this.visibleURL = `${this.tagUrl}?page=${this.currentPage}`;
    window.history.replaceState({}, "", this.visibleURL);

    fetch(this.filterURL)
      .then((response) => response.text())
      .then((data) => {
        let html_div = document.createElement("div");
        html_div.innerHTML = data;
        this.blogGrid.innerHTML = html_div.querySelector("[data-blog-articles]").innerHTML;
        this.pagination.innerHTML = html_div.querySelector("[data-pagination-wrap]").innerHTML;
      })
      .catch((error) => console.error("Error:", error))
      .finally(() => {
        this.classList.remove("loading");
      });
  }
}

customElements.define("blog-main", BlogMain);

class ArticleMain extends HTMLElement {
  constructor() {
    super();
    this.category = this.getAttribute("data-category");
    this.blogHandle = this.getAttribute("data-blog");
    this.categories = [];

    this.categoriesList = this.querySelector("[data-categories-list]");
    this.categoriesWrap = this.querySelector("[data-categories-wrap]");
    this.tableToggle = this.querySelector("[data-table-toggle]");

    this.tableOfContents = this.querySelector("[data-table-of-contents]");
    this.tableList = this.querySelector("[data-table-list]");
    this.content = this.querySelector("[data-content]");

    this.init();
    this.appendBlocks();
    this.renderAnchors();
    this.updateTableOfContentsSticky();
  }

  init() {
    this.tableToggle.addEventListener("click", () => {
      this.tableToggle.classList.toggle("active");
    });

    window.addEventListener("scroll", this.updateTableOfContentsSticky, { passive: true });
  }

  updateTableOfContentsSticky = () => {
    if (!this.tableOfContents || !this.tableList) return;

    const rect = this.tableOfContents.getBoundingClientRect();
    const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
    // Check if the entire element is visible in the viewport
    const fullyInView = rect.top + this.tableOfContents.offsetHeight >= 0;

    if (!fullyInView) {
      this.tableList.classList.add("fixed");
      // Fix the height so the list doesn't jump
      this.tableOfContents.style.height = `${rect.height}px`;
    } else {
      this.tableList.classList.remove("fixed");
      this.tableOfContents.style.height = "";
    }
  };

  renderAnchors() {
    if (!this.content || !this.tableList) return;

    const headings = this.content.querySelectorAll("h1, h2, h3, h4, h5, h6");
    if (!headings.length) {
      this.tableOfContents.classList.add("hidden");
      return;
    }

    this.tableOfContents.classList.remove("hidden");
    const buttons = [];
    headings.forEach((heading, index) => {
      const id = `heading-${index + 1}`;
      heading.setAttribute("id", id);
      const button = this.createAnchorButton(heading.textContent, id, buttons);
      this.tableList.appendChild(button);
      buttons.push(button);
    });

    const setActiveOnScroll = () => this.updateActiveAnchor(headings, buttons);

    window.addEventListener("scroll", setActiveOnScroll, { passive: true });
    setActiveOnScroll();
  }

  createAnchorButton(text, id, buttons) {
    const button = document.createElement("button");
    button.className = "article__table-button";
    const span = document.createElement("span");
    span.textContent = text;
    button.appendChild(span);
    button.onclick = () => {
      const headingElement = document.getElementById(id);
      const offset = 100;
      const elementPosition = headingElement.getBoundingClientRect().top + window.pageYOffset;
      window.scrollTo({
        top: elementPosition - offset,
        behavior: "smooth",
      });
    };
    return button;
  }

  updateActiveAnchor(headings, buttons) {
    const scrollPosition = window.scrollY || window.pageYOffset;
    const offset = 200;
    let activeIndex = -1;
    headings.forEach((heading, i) => {
      const rect = heading.getBoundingClientRect();
      const top = rect.top + window.scrollY - offset;
      if (scrollPosition >= top) {
        activeIndex = i;
      }
    });
    buttons.forEach((btn, i) => btn.classList.toggle("active", i === activeIndex));
  }

  appendBlocks() {
    const blocksContainer = this.querySelector("[data-article-blocks]");
    const contentContainer = this.querySelector("[data-content]");

    if (blocksContainer && contentContainer) {
      blocksContainer.querySelectorAll("[data-block-id]").forEach((block) => {
        let dataBlockId = block.getAttribute("data-block-id");
        contentContainer.querySelectorAll(`[data-block-id="${dataBlockId}"]`).forEach((item) => {
          item.innerHTML = block.outerHTML;
        });
      });
    }
  }
}

customElements.define("article-main", ArticleMain);

class SectionContact extends HTMLElement {
  static trackingSubmissions = new Set();

  constructor() {
    super();
    this.select = this.querySelector("[data-contact-select]");
    this.orderField = this.querySelector("[data-order-issue]");
    this.orderFieldInputRequired = this.querySelector("[data-order-issue-input-required]");

    this.init();
    this.initContactTracking();
  }

  init() {
    if (!this.select || !this.orderField) return;

    this.select.addEventListener("change", () => {
      const value = this.select.value.toLowerCase();
      if (value.indexOf("order") !== -1) {
        this.orderField.classList.remove("hidden");
        if (this.orderFieldInputRequired) {
          this.orderFieldInputRequired.setAttribute("required", true);
        }
      } else {
        this.orderField.classList.add("hidden");
        if (this.orderFieldInputRequired) {
          this.orderFieldInputRequired.removeAttribute("required");
        }
      }
    });
  }

  initContactTracking() {
    this.contactForm = this.querySelector('form input[name="form_type"][value="contact"]')?.form;
    if (!this.contactForm || window.Shopify?.designMode) return;

    this.contactStorageKey = `klaviyo:contact:${window.location.pathname}:${this.dataset.sectionId}`;
    this.contactForm.addEventListener("submit", () => this.saveContactSubmission(), { capture: true });

    if (!this.contactForm.querySelector("[data-contact-posted-successfully]")) {
      this.clearContactSubmission();
      return;
    }

    this.successfulContactSubmissionId = this.getContactSubmission()?.id;
    if (!this.successfulContactSubmissionId) return;

    this.contactConsentHandler = () => {
      this.contactTrackingAttempts = 0;
      clearTimeout(this.contactTrackingTimer);
      this.trackContactSubmission();
    };
    document.addEventListener("visitorConsentCollected", this.contactConsentHandler);

    if (!window.Shopify?.customerPrivacy && window.Shopify?.loadFeatures) {
      window.Shopify.loadFeatures([{ name: "consent-tracking-api", version: "0.1" }], (error) => {
        if (!error && this.isConnected) this.contactConsentHandler();
      });
    }

    this.contactConsentHandler();
  }

  disconnectedCallback() {
    clearTimeout(this.contactTrackingTimer);
    if (this.contactConsentHandler) {
      document.removeEventListener("visitorConsentCollected", this.contactConsentHandler);
    }
  }

  saveContactSubmission() {
    clearTimeout(this.contactTrackingTimer);
    this.successfulContactSubmissionId = null;
    this.clearContactSubmission();
    const emailInput = this.contactForm.querySelector('[name="contact[email]"]');
    const email = emailInput?.value.trim();
    if (!email || !this.contactForm.checkValidity()) {
      this.clearContactSubmission();
      return;
    }

    try {
      const submission = {
        id: crypto.randomUUID(),
        email,
        createdAt: Date.now(),
      };
      sessionStorage.setItem(this.contactStorageKey, JSON.stringify(submission));
    } catch {}
  }

  getContactSubmission() {
    try {
      const submission = JSON.parse(sessionStorage.getItem(this.contactStorageKey));
      if (
        typeof submission?.id === "string" &&
        typeof submission.email === "string" &&
        submission.email &&
        Number.isFinite(submission.createdAt) &&
        Date.now() >= submission.createdAt &&
        Date.now() - submission.createdAt < 30 * 60 * 1000
      ) {
        return submission;
      }
      this.clearContactSubmission();
    } catch {}
    return null;
  }

  clearContactSubmission() {
    try {
      sessionStorage.removeItem(this.contactStorageKey);
    } catch {}
  }

  contactTrackingAllowed() {
    const privacy = window.Shopify?.customerPrivacy;
    return privacy?.analyticsProcessingAllowed?.() === true && privacy?.marketingAllowed?.() === true;
  }

  async trackContactSubmission() {
    if (!this.isConnected || !this.contactForm.querySelector("[data-contact-posted-successfully]")) return;

    const submission = this.getContactSubmission();
    if (
      !submission ||
      submission.id !== this.successfulContactSubmissionId ||
      SectionContact.trackingSubmissions.has(submission.id)
    ) {
      return;
    }

    const klaviyo = window.klaviyo;
    if (
      !this.contactTrackingAllowed() ||
      typeof klaviyo?.identify !== "function" ||
      typeof klaviyo?.track !== "function"
    ) {
      if (this.contactTrackingAttempts++ < 120) {
        this.contactTrackingTimer = setTimeout(() => this.trackContactSubmission(), 1000);
      }
      return;
    }

    SectionContact.trackingSubmissions.add(submission.id);
    try {
      await klaviyo.identify({ email: submission.email });
      if (
        !this.isConnected ||
        !this.contactTrackingAllowed() ||
        this.successfulContactSubmissionId !== submission.id ||
        this.getContactSubmission()?.id !== submission.id
      ) {
        return;
      }

      const tracked = await klaviyo.track("Submitted Contact Form", {
        $event_id: submission.id,
        FormId: this.contactForm.id,
        PagePath: window.location.pathname,
      });
      if (tracked === true && this.getContactSubmission()?.id === submission.id) {
        this.clearContactSubmission();
      }
    } catch {
    } finally {
      SectionContact.trackingSubmissions.delete(submission.id);
    }
  }
}

customElements.define("section-contact", SectionContact);

class ExternalLinks extends HTMLElement {
  constructor() {
    super();
    this.init();
  }

  init() {
    const links = document.links;
    for (let i = 0; i < links.length; i++) {
      if (links[i].hostname !== window.location.hostname) {
        links[i].target = "_blank";
        links[i].rel = "noreferrer noopener";
      }
    }
  }
}

customElements.define("external-links", ExternalLinks);

class CartDrawer extends HTMLElement {
  constructor() {
    super();
    this.isOpen = false;
    this.isProcessing = false;
    this.requestQueue = [];
    this.cartItems = this.querySelector("[data-cart-items]");
    this.cartTotal = this.querySelector("[data-cart-total]");
    this.cartFooter = this.querySelector("[data-cart-footer]");
    this.cartCount = document.querySelectorAll("[data-cart-count]");
    this.previouslyFocusedElement = null;
    this.focusableElements = null;
    this.clickHandler = null;
    this.submitHandler = null;
    this.init();
  }

  init() {
    document.querySelectorAll("[data-open-cart]").forEach((button) => {
      button.addEventListener("click", (e) => {
        e.preventDefault();
        this.openCart();
      });
    });

    document.querySelectorAll("[data-close-cart]").forEach((button) => {
      button.addEventListener("click", (e) => {
        e.preventDefault();
        this.closeCart();
      });
    });

    this.addEventListener("click", (e) => {
      if (e.target.closest("[data-cart-remove]")) {
        e.preventDefault();
        const key = e.target.closest("[data-cart-remove]").getAttribute("data-cart-remove");
        this.removeItem(key);
      }

      if (e.target.closest("[data-cart-increase]")) {
        e.preventDefault();
        const key = e.target.closest("[data-cart-increase]").getAttribute("data-cart-increase");
        this.updateQuantity(key, 1);
      }

      if (e.target.closest("[data-cart-decrease]")) {
        e.preventDefault();
        const key = e.target.closest("[data-cart-decrease]").getAttribute("data-cart-decrease");
        this.updateQuantity(key, -1);
      }
    });

    this.addEventListener("keydown", (e) => {
      if (e.key === "Escape" && this.isOpen) {
        this.closeCart();
      }

      if (e.key === "Tab") {
        this.trapFocus(e);
      }
    });

    document.addEventListener("mousedown", (event) => {
      if (!this.isOpen) return;
      if (!this.contains(event.target) && !event.target.closest("[data-open-cart]")) {
        this.closeCart();
      }
    });

    if (this.clickHandler) {
      document.removeEventListener("click", this.clickHandler);
    }

    this.clickHandler = (e) => {
      const quickAddButton = e.target.closest("[data-quick-add]");
      if (quickAddButton) {
        e.preventDefault();
        e.stopImmediatePropagation();
        if (this.isProcessing) return;
        const variantId = quickAddButton.getAttribute("data-quick-add");
        this.addToCart(variantId, 1);
      }
    };

    document.addEventListener("click", this.clickHandler);

    if (this.submitHandler) {
      document.removeEventListener("submit", this.submitHandler);
    }

    this.submitHandler = (e) => {
      const productForm = e.target.closest("[data-product-form]");
      if (productForm) {
        e.preventDefault();
        e.stopImmediatePropagation();
        if (this.isProcessing) return;
        const formData = new FormData(productForm);
        const variantId = formData.get("id");
        const quantity = formData.get("quantity") || 1;
        const sellingPlanId = formData.get("selling_plan");
        this.addToCart(variantId, quantity, sellingPlanId);
      }
    };

    document.addEventListener("submit", this.submitHandler);
  }

  getFocusableElements() {
    return this.querySelectorAll(
      'button:not([disabled]), [href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
    );
  }

  trapFocus(e) {
    if (!this.isOpen) return;

    this.focusableElements = this.getFocusableElements();
    const firstElement = this.focusableElements[0];
    const lastElement = this.focusableElements[this.focusableElements.length - 1];

    if (e.shiftKey && document.activeElement === firstElement) {
      e.preventDefault();
      lastElement.focus();
    } else if (!e.shiftKey && document.activeElement === lastElement) {
      e.preventDefault();
      firstElement.focus();
    }
  }

  openCart() {
    this.previouslyFocusedElement = document.activeElement;
    this.isOpen = true;
    this.classList.add("open");
    document.body.classList.add("muted");

    setTimeout(() => {
      this.focus();
      const closeButton = this.querySelector("[data-close-cart]");
      if (closeButton) {
        closeButton.focus();
      }
    }, 100);
  }

  closeCart() {
    this.isOpen = false;
    this.classList.remove("open");
    document.body.classList.remove("muted");

    if (this.previouslyFocusedElement) {
      this.previouslyFocusedElement.focus();
      this.previouslyFocusedElement = null;
    }
  }

  async addToCart(variantId, quantity, sellingPlanId) {
    if (!variantId) {
      console.error("No variant ID provided");
      return;
    }

    if (this.isProcessing) {
      console.log("Cart operation already in progress, ignoring duplicate request");
      return;
    }

    const now = Date.now();
    if (this.lastAddTime && now - this.lastAddTime < 500) {
      console.log("Preventing rapid successive add to cart");
      return;
    }

    this.isProcessing = true;
    this.lastAddTime = now;

    try {
      const response = await fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          id: variantId,
          quantity: quantity,
          selling_plan: sellingPlanId,
        }),
      });

      if (response.ok) {
        await this.updateCart();
        this.openCart();
      } else {
        const errorData = await response.json();
        console.error("Failed to add item to cart:", errorData);
      }
    } catch (error) {
      console.error("Error adding to cart:", error);
    } finally {
      this.isProcessing = false;
    }
  }

  async removeItem(key) {
    const cartItem = this.querySelector(`[data-cart-item="${key}"]`);

    if (cartItem) {
      cartItem.style.opacity = "0.5";
      cartItem.style.pointerEvents = "none";
    }

    try {
      const response = await fetch("/cart/change.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          id: key,
          quantity: 0,
        }),
      });

      if (response.ok) {
        await this.updateCart();
      } else {
        if (cartItem) {
          cartItem.style.opacity = "1";
          cartItem.style.pointerEvents = "auto";
        }
      }
    } catch (error) {
      console.error("Error removing item:", error);
      if (cartItem) {
        cartItem.style.opacity = "1";
        cartItem.style.pointerEvents = "auto";
      }
    }
  }

  async updateQuantity(key, change) {
    const qtyElement = this.querySelector(`[data-cart-qty="${key}"]`);
    const cartItem = this.querySelector(`[data-cart-item="${key}"]`);
    const currentQty = parseInt(qtyElement.textContent);
    const newQty = currentQty + change;

    if (newQty < 1) {
      this.removeItem(key);
      return;
    }

    qtyElement.textContent = newQty;

    if (cartItem) {
      cartItem.style.opacity = "0.6";
      cartItem.style.pointerEvents = "none";
    }

    try {
      const response = await fetch("/cart/change.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          id: key,
          quantity: newQty,
        }),
      });

      if (response.ok) {
        await this.updateCart();
      } else {
        qtyElement.textContent = currentQty;
        if (cartItem) {
          cartItem.style.opacity = "1";
          cartItem.style.pointerEvents = "auto";
        }
      }
    } catch (error) {
      console.error("Error updating quantity:", error);
      qtyElement.textContent = currentQty;
      if (cartItem) {
        cartItem.style.opacity = "1";
        cartItem.style.pointerEvents = "auto";
      }
    } finally {
      if (cartItem) {
        cartItem.style.opacity = "1";
        cartItem.style.pointerEvents = "auto";
      }
    }
  }

  async updateCart() {
    try {
      const [cartResponse, sectionResponse] = await Promise.all([fetch("/cart.js"), fetch("/?section_id=cart-drawer")]);

      const [cartData, sectionText] = await Promise.all([cartResponse.json(), sectionResponse.text()]);

      const html = document.createElement("div");
      html.innerHTML = sectionText;

      const newCartItems = html.querySelector("[data-cart-items]");
      const newCartTotal = html.querySelector("[data-cart-total]");

      if (this.cartItems && newCartItems) {
        this.cartItems.innerHTML = newCartItems.innerHTML;
      }

      if (this.cartTotal && newCartTotal) {
        this.cartTotal.textContent = newCartTotal.textContent;
      }

      this.cartCount.forEach((count) => {
        count.textContent = cartData.item_count;
      });

      if (this.cartFooter) {
        if (cartData.item_count > 0) {
          this.cartFooter.classList.remove("hidden");
        } else {
          this.cartFooter.classList.add("hidden");
        }
      }
    } catch (error) {
      console.error("Error updating cart:", error);
    }
  }
}

customElements.define("cart-drawer", CartDrawer);

class FloatingImages extends HTMLElement {
  constructor() {
    super();
    this.init();
  }

  init() {
    // If this element is fully visible in the viewport, add 'active' class
    const onScroll = () => {
      const rect = this.getBoundingClientRect();
      const fullyVisible =
        rect.top >= 0 &&
        rect.left >= 0 &&
        rect.bottom - 250 <= (window.innerHeight || document.documentElement.clientHeight) &&
        rect.right <= (window.innerWidth || document.documentElement.clientWidth);
      if (fullyVisible) {
        this.classList.add("active");
      }
    };

    // Initial check
    onScroll();

    // Listen for scroll and resize events
    window.addEventListener("scroll", onScroll);
    window.addEventListener("resize", onScroll);

    // Clean up event listeners when element is removed (optional, but good practice)
    this._floatingImagesCleanup = () => {
      window.removeEventListener("scroll", onScroll);
      window.removeEventListener("resize", onScroll);
    };

    // When element is removed, clean up listeners
    this.addEventListener("disconnected", this._floatingImagesCleanup);
  }
}

customElements.define("floating-images", FloatingImages);

// --- Newsletter Form Validation ---

function initNewsletterForm() {
  const form = document.getElementById("newsletterForm");
  if (!form) return;

  const emailInput = form.querySelector('input[name="contact[email]"]');
  const errorBanner = document.getElementById("newsletter-empty-error");
  const serverErrorEl = document.getElementById("newsletter-server-error");

  if (!emailInput || !errorBanner) return;

  form.setAttribute("novalidate", "");
  errorBanner.classList.add("hidden");

  emailInput.addEventListener("input", function () {
    if (this.value.trim()) {
      errorBanner.classList.add("hidden");
    }
  });

  form.addEventListener("submit", function (e) {
    errorBanner.classList.add("hidden");
    if (serverErrorEl) serverErrorEl.classList.add("hidden");

    if (!emailInput.value.trim()) {
      e.preventDefault();
      e.stopPropagation();
      errorBanner.classList.remove("hidden");
      emailInput.focus();
      return false;
    }
  });
}

initNewsletterForm();

window.checkStickySection = (selector) => {
  const section = document.querySelector(selector);
  if (!section) return;

  const update = () => {
    const maxHeight = window.innerHeight - 150;
    section.classList.toggle("section-sticky", section.offsetHeight < maxHeight);
  };

  update();
  window.addEventListener("resize", update);
};
